import Call from '../Call';
import {objToQs} from '../Utils';

const PushapiBlock = {
    get(filters) {
        return Call(`pushapiBlock?${objToQs(filters)}`);
    },

    save(affid, subid) {
        return Call(`pushapiBlock`, 'POST', { affid, subid });
    },

    remove(id) {
        return Call(`pushapiBlock/${id}`, 'DELETE');
    }
}

export default PushapiBlock;


// WEBPACK FOOTER //
// ./src/services/API/components/PushapiBlock.js